export const Cyclist = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M27 13H21L16.2071 8.20711C15.8166 7.81658 15.1834 7.81658 14.7929 8.20711L10.2071 12.7929C9.81658 13.1834 9.81658 13.8166 10.2071 14.2071L15.7071 19.7071C15.8946 19.8946 16 20.149 16 20.4142V27" stroke="currentColor" stroke-width="2"/>
<circle cx="21.5" cy="4.5" r="2.5" stroke="currentColor" stroke-width="2"/>
<circle cx="25" cy="24" r="5" stroke="currentColor" stroke-width="2"/>
<circle cx="7" cy="24" r="5" stroke="currentColor" stroke-width="2"/>
</svg>`;
